/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeFarmConfigCreatedResponse,
  ApiEnvelopeFarmConfigListResponse,
  ApiEnvelopeFarmEmptyResponse,
  ApiEnvelopeFarmRunRecordingListResponse,
  ApiEnvelopeFarmRunResponse,
  FarmConfigInputDto,
  FarmGetFarmRecordingsParams,
  FarmStopFarmParams,
  ProblemDetails,
  RunFarmRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type farmGetFarmConfigsResponse200 = {
  data: ApiEnvelopeFarmConfigListResponse
  status: 200
}

export type farmGetFarmConfigsResponseSuccess = (farmGetFarmConfigsResponse200) & {
  headers: Headers;
};
;

export type farmGetFarmConfigsResponse = (farmGetFarmConfigsResponseSuccess)

export const getFarmGetFarmConfigsUrl = () => {




  return `/api/Farm`
}

export const useFarmGetFarmConfigsHook = (): ( options?: RequestInit) => Promise<farmGetFarmConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getFarmGetFarmConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type farmCreateFarmConfigResponse200 = {
  data: ApiEnvelopeFarmConfigCreatedResponse
  status: 200
}

export type farmCreateFarmConfigResponseSuccess = (farmCreateFarmConfigResponse200) & {
  headers: Headers;
};
;

export type farmCreateFarmConfigResponse = (farmCreateFarmConfigResponseSuccess)

export const getFarmCreateFarmConfigUrl = () => {




  return `/api/Farm`
}

export const useFarmCreateFarmConfigHook = (): (farmConfigInputDto?: FarmConfigInputDto, options?: RequestInit) => Promise<farmCreateFarmConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (farmConfigInputDto?: FarmConfigInputDto, options?: RequestInit) => {

        return customFetcher(getFarmCreateFarmConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(farmConfigInputDto)
  }
);
      }
  }


export type farmUpdateFarmConfigResponse200 = {
  data: ApiEnvelopeFarmEmptyResponse
  status: 200
}

export type farmUpdateFarmConfigResponse404 = {
  data: ApiEnvelopeFarmEmptyResponse
  status: 404
}

export type farmUpdateFarmConfigResponseSuccess = (farmUpdateFarmConfigResponse200) & {
  headers: Headers;
};
export type farmUpdateFarmConfigResponseError = (farmUpdateFarmConfigResponse404) & {
  headers: Headers;
};

export type farmUpdateFarmConfigResponse = (farmUpdateFarmConfigResponseSuccess | farmUpdateFarmConfigResponseError)

export const getFarmUpdateFarmConfigUrl = (id: string,) => {




  return `/api/Farm/${id}`
}

export const useFarmUpdateFarmConfigHook = (): (id: string,
    farmConfigInputDto?: FarmConfigInputDto, options?: RequestInit) => Promise<farmUpdateFarmConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    farmConfigInputDto?: FarmConfigInputDto, options?: RequestInit) => {

        return customFetcher(getFarmUpdateFarmConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(farmConfigInputDto)
  }
);
      }
  }


export type farmDeleteFarmConfigResponse200 = {
  data: ApiEnvelopeFarmEmptyResponse
  status: 200
}

export type farmDeleteFarmConfigResponse404 = {
  data: ApiEnvelopeFarmEmptyResponse
  status: 404
}

export type farmDeleteFarmConfigResponseSuccess = (farmDeleteFarmConfigResponse200) & {
  headers: Headers;
};
export type farmDeleteFarmConfigResponseError = (farmDeleteFarmConfigResponse404) & {
  headers: Headers;
};

export type farmDeleteFarmConfigResponse = (farmDeleteFarmConfigResponseSuccess | farmDeleteFarmConfigResponseError)

export const getFarmDeleteFarmConfigUrl = (id: string,) => {




  return `/api/Farm/${id}`
}

export const useFarmDeleteFarmConfigHook = (): (id: string, options?: RequestInit) => Promise<farmDeleteFarmConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getFarmDeleteFarmConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type farmRunFarmConfigResponse200 = {
  data: ApiEnvelopeFarmRunResponse
  status: 200
}

export type farmRunFarmConfigResponse400 = {
  data: ApiEnvelopeFarmRunResponse
  status: 400
}

export type farmRunFarmConfigResponse404 = {
  data: ApiEnvelopeFarmRunResponse
  status: 404
}

export type farmRunFarmConfigResponseSuccess = (farmRunFarmConfigResponse200) & {
  headers: Headers;
};
export type farmRunFarmConfigResponseError = (farmRunFarmConfigResponse400 | farmRunFarmConfigResponse404) & {
  headers: Headers;
};

export type farmRunFarmConfigResponse = (farmRunFarmConfigResponseSuccess | farmRunFarmConfigResponseError)

export const getFarmRunFarmConfigUrl = (id: string,) => {




  return `/api/Farm/${id}/run`
}

export const useFarmRunFarmConfigHook = (): (id: string,
    runFarmRequest?: RunFarmRequest, options?: RequestInit) => Promise<farmRunFarmConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runFarmRequest?: RunFarmRequest, options?: RequestInit) => {

        return customFetcher(getFarmRunFarmConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runFarmRequest)
  }
);
      }
  }


export type farmGetFarmRecordingsResponse200 = {
  data: ApiEnvelopeFarmRunRecordingListResponse
  status: 200
}

export type farmGetFarmRecordingsResponse403 = {
  data: ApiEnvelopeFarmRunRecordingListResponse
  status: 403
}

export type farmGetFarmRecordingsResponseSuccess = (farmGetFarmRecordingsResponse200) & {
  headers: Headers;
};
export type farmGetFarmRecordingsResponseError = (farmGetFarmRecordingsResponse403) & {
  headers: Headers;
};

export type farmGetFarmRecordingsResponse = (farmGetFarmRecordingsResponseSuccess | farmGetFarmRecordingsResponseError)

export const getFarmGetFarmRecordingsUrl = (params?: FarmGetFarmRecordingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Farm/recordings?${stringifiedParams}` : `/api/Farm/recordings`
}

export const useFarmGetFarmRecordingsHook = (): (params?: FarmGetFarmRecordingsParams, options?: RequestInit) => Promise<farmGetFarmRecordingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: FarmGetFarmRecordingsParams, options?: RequestInit) => {

        return customFetcher(getFarmGetFarmRecordingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type farmExportFarmRecordingResponse200 = {
  data: void
  status: 200
}

export type farmExportFarmRecordingResponse403 = {
  data: ProblemDetails
  status: 403
}

export type farmExportFarmRecordingResponse404 = {
  data: ProblemDetails
  status: 404
}

export type farmExportFarmRecordingResponseSuccess = (farmExportFarmRecordingResponse200) & {
  headers: Headers;
};
export type farmExportFarmRecordingResponseError = (farmExportFarmRecordingResponse403 | farmExportFarmRecordingResponse404) & {
  headers: Headers;
};

export type farmExportFarmRecordingResponse = (farmExportFarmRecordingResponseSuccess | farmExportFarmRecordingResponseError)

export const getFarmExportFarmRecordingUrl = (recordingId: string,) => {




  return `/api/Farm/recordings/${recordingId}/export`
}

export const useFarmExportFarmRecordingHook = (): (recordingId: string, options?: RequestInit) => Promise<farmExportFarmRecordingResponse> => {

      const customFetcher = useSfetchMutator();
      return (recordingId: string, options?: RequestInit) => {

        return customFetcher(getFarmExportFarmRecordingUrl(recordingId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type farmStopFarmResponse200 = {
  data: ApiEnvelopeFarmEmptyResponse
  status: 200
}

export type farmStopFarmResponse404 = {
  data: ApiEnvelopeFarmEmptyResponse
  status: 404
}

export type farmStopFarmResponseSuccess = (farmStopFarmResponse200) & {
  headers: Headers;
};
export type farmStopFarmResponseError = (farmStopFarmResponse404) & {
  headers: Headers;
};

export type farmStopFarmResponse = (farmStopFarmResponseSuccess | farmStopFarmResponseError)

export const getFarmStopFarmUrl = (id: string,
    params?: FarmStopFarmParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Farm/${id}/stop?${stringifiedParams}` : `/api/Farm/${id}/stop`
}

export const useFarmStopFarmHook = (): (id: string,
    params?: FarmStopFarmParams, options?: RequestInit) => Promise<farmStopFarmResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: FarmStopFarmParams, options?: RequestInit) => {

        return customFetcher(getFarmStopFarmUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


